export const PRIVACY_POLICY_URL = 'https://docs.google.com/document/d/1t6Xt8oPekv4Djv52CZJYr8JWnNNkvU1leX5y7uro798/preview'